<template>
    <div class="container">
        <h1>User profile</h1>
        <div class="row justify-content-center">
            <div class="col">
                <EditUserForm v-model="user" @save="save" @user="userLoaded" :cancel="false" />
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/lib/api'
import {mapGetters} from 'vuex'

import EditUserForm from '@/components/user/EditUserForm.vue'

export default {
    name: 'UserProfilePage',
    components: {
        EditUserForm
    },
    head() {
        return {
            title: this.pageTitle
        }
    },
    data: () => {
        return {
            user: undefined
        }
    },
    computed: {
        ...mapGetters('auth', ['userinfo']),
        pageTitle () {
            if (!this.user) {
                return 'User Profile'
            }

            return `${this.user.first_name} ${this.user.last_name}`
        }
    },
    methods: {
        userLoaded (user) {
            this.user = user
        },
        save(user) {
            api.user.editUser (this.userinfo.id, {...user}).then(() => {
                this.$notify({
                    title: 'Success',
                    message: `User profile saved`,
                    type: 'success'
                })

                api.auth.refreshUserinfo()
            }).catch(error => {
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not save user information: ${err}`,
                    type: 'error'
                })
            })
        }
    },
    created () {
        this.user = {...this.userinfo}
    }
}
</script>